export default __webpack_public_path__ + "static/media/new-kingdom-points-tutorial-3x.89bb20af.webp";